import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { getEventPersonnels } from "../../services/eventPersonnelServices";

export const AccreditedChefList = (props) => {
    const [personnelList, setPersonnelList] = useState([]);
    const [oldPersonnelList, setOldPersonnelList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 50;

    const getData = () => {
        getEventPersonnels(props.uniqueKey).then((result) => {
            result.items.forEach((f, i) => {
                f["key"] = i;
            });
            const itemList = result.items
                .filter((f) => f.personnelType == 1 && f.isAttended)
                .map((it, i) => {
                    it.index = i + 1;
                    return it;
                });
            setPersonnelList(itemList);
            setOldPersonnelList(itemList);
        });
    };

    const handleSearch = (value) => {
        setSearchTerm(value);
        if (!value) {
            setPersonnelList(oldPersonnelList);
            setCurrentPage(1);
            return;
        }
        const upper = value.toLocaleUpperCase();
        const lower = value.toLocaleLowerCase();
        const search = (key) => key.toLocaleUpperCase().indexOf(upper) > -1 || key.toLocaleLowerCase().indexOf(lower) > -1;
        setPersonnelList(
            oldPersonnelList.filter(
                (w) =>
                    search(w.name) ||
                    search(w.surname) ||
                    search(w.identityNumber) ||
                    w.oggNumber == value ||
                    search(w.eventSupplierName)
            )
        );
        setCurrentPage(1);
    };

    const excelExport = (type) => {
        getEventPersonnels(props.uniqueKey, false, "excel", type).then((result) => {
            const url = window.URL.createObjectURL(new Blob([result]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Etkinlik Personel Listesi.xlsx");
            document.body.appendChild(link);
            link.click();
            return;
        });
    };

    useEffect(() => {
        getData();
    }, []);

    const totalPages = Math.ceil(personnelList.length / pageSize);
    const paginatedData = personnelList.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const renderChefCards = () => {
        if (!personnelList || personnelList.length === 0) {
            return <div className="mobile-empty-text">⚠ Kayıt yapılmış personel bulunmamakta.</div>;
        }
        return personnelList.map((record) => (
            <div key={record.key} className="modal-personnel-card">
                <div className="modal-card-header">
                    <div className="modal-card-no">{record.index}</div>
                    <div className="modal-card-name">{record.name} {record.surname}</div>
                    <div className="modal-card-type">{record.eventSupplierName || ""}</div>
                </div>
                <div className="modal-card-body">
                    <div className="modal-card-row">
                        <span className="info-label">TC Kimlik</span>
                        <span className="info-value">{record.identityNumber}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">ÖGG No</span>
                        <span className="info-value">{record.oggNumber || "-"}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">ÖGG Bitiş</span>
                        <span className="info-value">{record.oggExpireDate ? moment(record.oggExpireDate).format("DD.MM.YYYY") : "-"}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">Telefon</span>
                        <span className="info-value">{record.phoneNumber || "-"}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">Görev Yeri</span>
                        <span className="info-value">{record.eventPlaceLocationName || "-"}</span>
                    </div>
                </div>
            </div>
        ));
    };

    return (
        <>
            <div className="flex flex-wrap gap-2 mb-4">
                <button className="app-btn btn-green" onClick={() => excelExport("chef")}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                    <span>Excel'e Aktar</span>
                </button>
                <input
                    type="text"
                    placeholder="Ara..."
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
            </div>
            <div className="mobile-tab-cards">
                {renderChefCards()}
            </div>
            <div className="desktop-tab-table">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                            <tr>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">#</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Adı</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Soyadı</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">TC Kimlik</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">ÖGG Numarası</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Telefon</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Görev Yeri</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Şirket</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                            {paginatedData.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="px-3 py-8 text-center text-gray-500 dark:text-gray-400">⚠ Kayıt yapılmış personel bulunmamakta.</td>
                                </tr>
                            ) : paginatedData.map((record) => (
                                <tr key={record.key} className="hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800">
                                    <td className="px-3 py-2 whitespace-nowrap">{record.index}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.name}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.surname}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.identityNumber}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        <div className="inline-flex items-center gap-1.5">
                                            <span>{record.oggNumber || "-"}</span>
                                            {record.oggExpireDate && (
                                                <span
                                                    className="relative group inline-flex items-center cursor-pointer text-blue-500 hover:text-blue-600"
                                                    title={`ÖGG Bitiş Tarihi: ${moment(record.oggExpireDate).format("DD.MM.YYYY")}`}
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                    <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:flex px-2 py-1 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap z-50 pointer-events-none">
                                                        Bitiş: {moment(record.oggExpireDate).format("DD.MM.YYYY")}
                                                    </span>
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.phoneNumber}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.eventPlaceLocationName}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.eventSupplierName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 && (
                    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 dark:border-gray-700">
                        <span className="text-sm text-gray-700 dark:text-gray-300">Toplam {personnelList.length} Kayıt Bulunuyor</span>
                        <div className="flex items-center gap-2">
                            <button
                                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                                className="px-3 py-1 text-sm border border-gray-300 rounded disabled:opacity-50 hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800"
                            >
                                Önceki
                            </button>
                            <span className="text-sm text-gray-700 dark:text-gray-300">{currentPage} / {totalPages}</span>
                            <button
                                onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                                className="px-3 py-1 text-sm border border-gray-300 rounded disabled:opacity-50 hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800"
                            >
                                Sonraki
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
